import React from "react";
import PropTypes from "prop-types";

import style from "./style.module.scss";

export function SubHeading(props) {
  return (
    <div
      role="button"
      tabIndex={0}
      className={`${style.sliderHeader} ${props.className}`}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          // Add the interaction logic here, if needed
        }
      }}
    >
      {props.text}
    </div>
  );
}

SubHeading.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * text to be displayed in header
   */
  text: PropTypes.string,
};
